import $ from "jquery";
import {rates} from "./instant";

let btcRate;

const SUCCESS = 'bg-success',
    WARNING = 'bg-warning',
    DANGER = 'bg-danger'

const sliderTrackStyle = (value, elementId) => {
    if (value < 50) {
        if (elementId.hasClass(WARNING)) {
            elementId.removeClass(WARNING)
        }
        if (elementId.hasClass(DANGER)) {
            elementId.removeClass(DANGER)
        }
        elementId.addClass(SUCCESS);
    }
    if (value >= 50 && value < 80) {
        if (elementId.hasClass(SUCCESS)) {
            elementId.removeClass(SUCCESS)
        }
        if (elementId.hasClass(DANGER)) {
            elementId.removeClass(DANGER)
        }
        elementId.addClass(WARNING);
    }
    if (value >= 80) {
        if (elementId.hasClass(SUCCESS)) {
            elementId.removeClass(SUCCESS)
        }
        if (elementId.hasClass(WARNING)) {
            elementId.removeClass(WARNING)
        }
        elementId.addClass(DANGER);
    }
}

const calcCurrentLtv = () => {
    if (btcRate) {
        const usedLoanLimit = parseFloat($('#used-loan-limit').text().replace(/,/, '.'));
        const btcBalance = parseFloat($('#user-balance-btc').text().replace(/,/, '.'));
        const btcBalanceUsd = Math.round(btcBalance / btcRate * 100) / 100;
        let ltvPercent = Math.ceil( usedLoanLimit / btcBalanceUsd * 100 );

        if (ltvPercent < 1) {
            ltvPercent = '< 1'
        } else if (ltvPercent > 90) {
            ltvPercent = 90
        }

        return ltvPercent;
    }
}

function rate() {
    $.ajax({
        type: 'POST',
        url: '/rates',
        data: {},
        dataType : "json",
        success: function (result) {
            if (result) {
                if (!result.error) {
                    btcRate = result['BTC']['rate'];
                } else {
                    return false;
                }
            }
        }
    });
}

const ratesList = () => {
    calcProgressBar();
}

const calcProgressBar = () => {
    let value = calcCurrentLtv();
    const progressBlock = $('#progress_block');
    const progressBlockSm = $('#progress_block_sm');
    progressBlock.removeClass('d-none')
    progressBlockSm.removeClass('d-none')
    const progressBar = $('#progress_bar')
    const progressBarSM = $('#progress_bar_sm')
    progressBar.width(`${value}%`)
    progressBarSM.width(`${value}%`)
    $('#current-ltv').text(value);
    $('#current-ltv-sm').text(value);
    sliderTrackStyle(value, progressBar);
    sliderTrackStyle(value, progressBarSM);
}

$( document ).ready( function() {
    rate()
    setTimeout(
        ratesList,
        2000)
});
